export default __webpack_public_path__ + "static/img2-ef5bfbe1c4f1840047d14910f59ffbef.jpg";